"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractGuestOperationFields = void 0;
var guest_interface_dynamodb_helpers_1 = require("./guest-interface-dynamodb-helpers");
Object.defineProperty(exports, "extractGuestOperationFields", { enumerable: true, get: function () { return guest_interface_dynamodb_helpers_1.extractGuestOperationFields; } });
